import { render, staticRenderFns } from "./ViewProductsBenefits.vue?vue&type=template&id=091a9860"
import script from "./ViewProductsBenefits.vue?vue&type=script&lang=js"
export * from "./ViewProductsBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports